// extracted by mini-css-extract-plugin
export default {"nameContainer":"userName_nameContainer__ZF+xZ","threads":"userName_threads__fLJH7"};